import CardWrapper from "./CardWrapper";
import ManagementSidebar from "./ManagementSidebar";

const ManagementDashboard = () => {
  return (
    <div style={{ border: "2px solid red" }}>
      <CardWrapper />
    </div>
  );
};
export default ManagementDashboard;
